<template>
  <div class="view-gabarit">
    <h2 class="head-box-title flat">{{ isOwner ? $t('modal.deleteValidation') : $t('modal.unfollowValidation') }}</h2>
    <div class="centered">{{ isOwner ? $t('modal.deleteValidationNotice') : $t('modal.unfollowValidationNotice') }}</div>
    <div class="cta-container">
      <button class="study-button" @click="() => $emit('closeModal')">{{ $t('cancel') }}</button>
      <button class="study-button main" @click="deleteStudy">{{ $t('validate') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['params'],

  computed: {
    isOwner() {
      return this.params.isOwner;
    },
  },

  methods: {
    deleteStudy() {
      const { id } = this.params;
      this.$emit('closeModal');
      this.$store.dispatch('deleteStudy', { id }).then(() => {
        this.$store.dispatch('fetchStudies');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.view-gabarit {
  width: 680px;

  .centered {
    margin-top: 8px;
    text-align: center;
  }

  .cta-container {
    padding: 38px;
    text-align: center;
    button {
      margin: 0 1em;
    }
  }
}
</style>
